import { History } from "history";

import {
  CopyCutSubjectRequest,
  CreateSubjectRequest,
  PaginateQuery,
  PurchaseableSubjectStudentDto,
  SubjectDto,
  UpdateSubjectRequest,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";
import {
  COPY_CUT_SUBJECT,
  COPY_CUT_SUBJECT_ERROR,
  COPY_CUT_SUBJECT_SUCCESS,
  CopyCutSubjectAction,
  CopyCutSubjectErrorAction,
  CopyCutSubjectSuccessAction,
  DELETE_SUBJECT,
  DELETE_SUBJECT_CONSENT,
  DELETE_SUBJECT_ERROR,
  DELETE_SUBJECT_SUCCESS,
  GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT,
  GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_ERROR,
  GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_SUCCESS,
  GET_SUBJECT_LIST_BY_GRADE,
  GET_SUBJECT_LIST_BY_GRADE_ERROR,
  GET_SUBJECT_LIST_BY_GRADE_SUCCESS,
  GetPurchaseableSubjectForStudentAction,
  GetPurchaseableSubjectForStudentErrorAction,
  GetPurchaseableSubjectForStudentSuccessAction,
  GetSubjectSelectListByGradeAction,
  GetSubjectSelectListByGradeErrorAction,
  GetSubjectSelectListByGradeSuccessAction,
  RESET_COPY_CUT_SUBJECT,
  RESET_PURCHASEABLE_SUBJECTS_FOR_STUDENT,
  RESET_SUBJECT_LIST_BY_GRADE,
  ResetCopyCutSubjectAction,
  ResetPurchaseableSubjectForStudentAction,
  ResetSubjectSelectListByGradeAction,
  TOGGLE_SUBJECT_STATE,
  TOGGLE_SUBJECT_STATE_CONSENT,
  TOGGLE_SUBJECT_STATE_ERROR,
  TOGGLE_SUBJECT_STATE_SUCCESS,
  ToggleSubjectStateAction,
  ToggleSubjectStateConsentAction,
  ToggleSubjectStateErrorAction,
  ToggleSubjectStateSuccessAction,
  UPDATE_SUBJECT,
  UPDATE_SUBJECT_ERROR,
  UPDATE_SUBJECT_SUCCESS,
  UPLOAD_SUBJECT_CONTENT_IMAGE,
  UPLOAD_SUBJECT_CONTENT_IMAGE_ERROR,
  UPLOAD_SUBJECT_CONTENT_IMAGE_SUCCESS,
  UPLOAD_SUBJECT_HOME_IMAGE,
  UPLOAD_SUBJECT_HOME_IMAGE_ERROR,
  UPLOAD_SUBJECT_HOME_IMAGE_SUCCESS,
  UploadSubjectContentImageAction,
  UploadSubjectContentImageErrorAction,
  UploadSubjectContentImageSuccessAction,
  UploadSubjectHomeImageAction,
  UploadSubjectHomeImageErrorAction,
  UploadSubjectHomeImageSuccessAction,
} from "../subject/actionTypes";
import {
  GetSubjectsByGradeAction,
  GET_SUBJECTS_BY_GRADE,
  GetSubjectsByGradeSuccessAction,
  GET_SUBJECTS_BY_GRADE_SUCCESS,
  GetSubjectsByGradeErrorAction,
  GET_SUBJECTS_BY_GRADE_ERROR,
  RESET_SUBJECTS_BY_GRADE,
  GetSubjectsAction,
  GetSubjectsErrorAction,
  GetSubjectsSuccessAction,
  GET_SUBJECTS,
  GET_SUBJECTS_ERROR,
  GET_SUBJECTS_SUCCESS,
  AddSubjectAction,
  AddSubjectErrorAction,
  AddSubjectSuccessAction,
  DeleteSubjectAction,
  DeleteSubjectConsentAction,
  DeleteSubjectErrorAction,
  DeleteSubjectSuccessAction,
  GetSubjectAction,
  GetSubjectErrorAction,
  GetSubjectSuccessAction,
  UpdateSubjectAction,
  UpdateSubjectErrorAction,
  UpdateSubjectSuccessAction,
  GET_SUBJECT,
  ADD_SUBJECT,
  ADD_SUBJECT_ERROR,
  ADD_SUBJECT_SUCCESS,
  GET_SUBJECT_ERROR,
  GET_SUBJECT_SUCCESS,
} from "./actionTypes";
import { MediaDto } from "../../interfaces/media";

//#region Get Subjects by Grade

export const getSubjectsByGrade = (
  gradeId: string
): GetSubjectsByGradeAction => {
  return {
    type: GET_SUBJECTS_BY_GRADE,
    payload: { gradeId },
  };
};

export const getSubjectsByGradeSuccess = (
  response: SubjectDto[]
): GetSubjectsByGradeSuccessAction => {
  return {
    type: GET_SUBJECTS_BY_GRADE_SUCCESS,
    payload: response,
  };
};

export const getSubjectsByGradeError = (
  error: any
): GetSubjectsByGradeErrorAction => {
  return {
    type: GET_SUBJECTS_BY_GRADE_ERROR,
    payload: error,
  };
};

export const resetSubjectsByGrade = (): GetSubjectsByGradeErrorAction => {
  return {
    type: RESET_SUBJECTS_BY_GRADE,
    payload: null,
  };
};

//#endregion

//#region Get Subjects

export const getSubjects = (
  request: PaginateQuery,
  history: History
): GetSubjectsAction => {
  return {
    type: GET_SUBJECTS,
    payload: { request, history },
  };
};

export const getSubjectsSuccess = (
  response: Paginated<SubjectDto>
): GetSubjectsSuccessAction => {
  return {
    type: GET_SUBJECTS_SUCCESS,
    payload: response,
  };
};

export const getSubjectsError = (error: any): GetSubjectsErrorAction => {
  return {
    type: GET_SUBJECTS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Subject

export const getSubject = (id: string, history: History): GetSubjectAction => {
  return {
    type: GET_SUBJECT,
    payload: { id, history },
  };
};

export const getSubjectSuccess = (
  response: SubjectDto
): GetSubjectSuccessAction => {
  return {
    type: GET_SUBJECT_SUCCESS,
    payload: response,
  };
};

export const getSubjectError = (error: any): GetSubjectErrorAction => {
  return {
    type: GET_SUBJECT_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Subject

export const addSubject = (
  request: CreateSubjectRequest,
  history: History
): AddSubjectAction => {
  return {
    type: ADD_SUBJECT,
    payload: { request, history },
  };
};

export const addSubjectSuccess = (): AddSubjectSuccessAction => {
  return {
    type: ADD_SUBJECT_SUCCESS,
    payload: null,
  };
};

export const addSubjectError = (error: any): AddSubjectErrorAction => {
  return {
    type: ADD_SUBJECT_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Subject

export const updateSubject = (
  id: string,
  request: UpdateSubjectRequest,
  history: History
): UpdateSubjectAction => {
  return {
    type: UPDATE_SUBJECT,
    payload: { id, request, history },
  };
};

export const updateSubjectSuccess = (): UpdateSubjectSuccessAction => {
  return {
    type: UPDATE_SUBJECT_SUCCESS,
    payload: null,
  };
};

export const updateSubjectError = (error: any): UpdateSubjectErrorAction => {
  return {
    type: UPDATE_SUBJECT_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Subject

export const deleteSubjectConsent = (
  id: string
): DeleteSubjectConsentAction => {
  return {
    type: DELETE_SUBJECT_CONSENT,
    payload: id,
  };
};

export const deleteSubject = (
  id: string,
  history: History
): DeleteSubjectAction => {
  return {
    type: DELETE_SUBJECT,
    payload: { id, history },
  };
};

export const deleteSubjectSuccess = (): DeleteSubjectSuccessAction => {
  return {
    type: DELETE_SUBJECT_SUCCESS,
    payload: null,
  };
};

export const deleteSubjectError = (error: any): DeleteSubjectErrorAction => {
  return {
    type: DELETE_SUBJECT_ERROR,
    payload: error,
  };
};

//#endregion

//#region Upload Subject Home Image

export const uploadSubjectHomeImage = (
  file: File,
  history: History,
  subjectId?: string
): UploadSubjectHomeImageAction => {
  return {
    type: UPLOAD_SUBJECT_HOME_IMAGE,
    payload: { file, history, subjectId },
  };
};

export const uploadSubjectHomeImageSuccess = (
  media: MediaDto
): UploadSubjectHomeImageSuccessAction => {
  return {
    type: UPLOAD_SUBJECT_HOME_IMAGE_SUCCESS,
    payload: media,
  };
};

export const uploadSubjectHomeImageError = (
  error: any
): UploadSubjectHomeImageErrorAction => {
  return {
    type: UPLOAD_SUBJECT_HOME_IMAGE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Upload Subject Content Image

export const uploadSubjectContentImage = (
  file: File,
  history: History,
  subjectId?: string
): UploadSubjectContentImageAction => {
  return {
    type: UPLOAD_SUBJECT_CONTENT_IMAGE,
    payload: { file, history, subjectId },
  };
};

export const uploadSubjectContentImageSuccess = (
  media: MediaDto
): UploadSubjectContentImageSuccessAction => {
  return {
    type: UPLOAD_SUBJECT_CONTENT_IMAGE_SUCCESS,
    payload: media,
  };
};

export const uploadSubjectContentImageError = (
  error: any
): UploadSubjectContentImageErrorAction => {
  return {
    type: UPLOAD_SUBJECT_CONTENT_IMAGE_ERROR,
    payload: error,
  };
};
//#endregion

//#region Copy Cut Subject
export const copyCutSubject = (
  request: CopyCutSubjectRequest,
  history: History
): CopyCutSubjectAction => {
  return {
    type: COPY_CUT_SUBJECT,
    payload: { request, history },
  };
};

export const CopyCutSubjectSubjectSuccess = (): CopyCutSubjectSuccessAction => {
  return {
    type: COPY_CUT_SUBJECT_SUCCESS,
    payload: null,
  };
};

export const CopyCutSubjectSubjectError = (
  error: any
): CopyCutSubjectErrorAction => {
  return {
    type: COPY_CUT_SUBJECT_ERROR,
    payload: error,
  };
};

export const resetCopyCutSubject = (): ResetCopyCutSubjectAction => {
  return {
    type: RESET_COPY_CUT_SUBJECT,
    payload: null,
  };
};

//#endregion

//#region Toggle Subject State

export const toggleSubjectStateConsent = (
  id: string
): ToggleSubjectStateConsentAction => {
  return {
    type: TOGGLE_SUBJECT_STATE_CONSENT,
    payload: id,
  };
};

export const toggleSubjectState = (
  id: string,
  history: History
): ToggleSubjectStateAction => {
  return {
    type: TOGGLE_SUBJECT_STATE,
    payload: { id, history },
  };
};

export const toggleSubjectStateSuccess = (
  id: string
): ToggleSubjectStateSuccessAction => {
  return {
    type: TOGGLE_SUBJECT_STATE_SUCCESS,
    payload: { id },
  };
};

export const toggleSubjectStateError = (
  error: any
): ToggleSubjectStateErrorAction => {
  return {
    type: TOGGLE_SUBJECT_STATE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Subject Select List by Grade

export const getSubjectSelectListByGrade = (
  gradeId: string
): GetSubjectSelectListByGradeAction => {
  return {
    type: GET_SUBJECT_LIST_BY_GRADE,
    payload: { gradeId },
  };
};

export const getSubjectSelectListByGradeSuccess = (
  response: SelectListDto[]
): GetSubjectSelectListByGradeSuccessAction => {
  return {
    type: GET_SUBJECT_LIST_BY_GRADE_SUCCESS,
    payload: response,
  };
};

export const getSubjectSelectListByGradeError = (
  error: any
): GetSubjectSelectListByGradeErrorAction => {
  return {
    type: GET_SUBJECT_LIST_BY_GRADE_ERROR,
    payload: error,
  };
};

export const resetSubjectSelectListByGrade =
  (): ResetSubjectSelectListByGradeAction => {
    return {
      type: RESET_SUBJECT_LIST_BY_GRADE,
      payload: {},
    };
  };

//#endregion

//#region Get Purchase Subjects for Student by providing course and grade id

export const getPurchaseableSubjectForStudent = (
  courseId: string,
  gradeId: string,
  userId: string
): GetPurchaseableSubjectForStudentAction => {
  return {
    type: GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT,
    payload: { courseId, gradeId, userId },
  };
};

export const getPurchaseableSubjectForStudentSuccess = (
  response: PurchaseableSubjectStudentDto[]
): GetPurchaseableSubjectForStudentSuccessAction => {
  return {
    type: GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_SUCCESS,
    payload: response,
  };
};

export const getPurchaseableSubjectForStudentError = (
  error: any
): GetPurchaseableSubjectForStudentErrorAction => {
  return {
    type: GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_ERROR,
    payload: error,
  };
};

export const resetPurchaseableSubjectForStudent =
  (): ResetPurchaseableSubjectForStudentAction => {
    return {
      type: RESET_PURCHASEABLE_SUBJECTS_FOR_STUDENT,
      payload: {},
    };
  };

//#endregion
